// Generated by ShopifyApp/services/storefront `bun run sync:openrouter-image-models`. Do not edit.
export const OPENROUTER_IMAGE_MODELS = {
    'google/gemini-3.1-flash-image': {
        label: 'Nano Banana 2',
        group: 'Gemini',
        params: {
            aspectRatio: [
                '1:1',
                '1:4',
                '1:8',
                '2:3',
                '3:2',
                '3:4',
                '4:1',
                '4:3',
                '4:5',
                '5:4',
                '8:1',
                '9:16',
                '16:9',
                '21:9'
            ],
            resolution: ['512', '1K', '2K', '4K']
        },
        defaults: {
            aspectRatio: '1:1',
            resolution: '1K'
        }
    },
    'google/gemini-3.1-flash-lite-image': {
        label: 'Nano Banana 2 Lite',
        group: 'Gemini',
        params: {
            aspectRatio: [
                '1:1',
                '1:4',
                '1:8',
                '2:3',
                '3:2',
                '3:4',
                '4:1',
                '4:3',
                '4:5',
                '5:4',
                '8:1',
                '9:16',
                '16:9',
                '21:9'
            ],
            resolution: ['1K']
        },
        defaults: {
            aspectRatio: '1:1',
            resolution: '1K'
        }
    },
    'google/gemini-3-pro-image': {
        label: 'Nano Banana Pro',
        group: 'Gemini',
        params: {
            aspectRatio: ['1:1', '2:3', '3:2', '3:4', '4:3', '4:5', '5:4', '9:16', '16:9', '21:9'],
            resolution: ['1K', '2K']
        },
        defaults: {
            aspectRatio: '1:1',
            resolution: '1K'
        }
    },
    'openai/gpt-image-1-mini': {
        label: 'gpt-image-1-mini',
        group: 'OpenAI',
        params: {
            aspectRatio: ['1:1', '3:2', '2:3', 'auto'],
            quality: ['auto', 'low', 'medium', 'high'],
            background: ['auto', 'transparent', 'opaque']
        },
        defaults: {
            aspectRatio: '1:1',
            quality: 'auto',
            background: 'auto'
        }
    },
    'openai/gpt-image-2': {
        label: 'gpt-image-2',
        group: 'OpenAI',
        params: {
            aspectRatio: ['1:1', '3:2', '2:3', '4:3', '3:4', '16:9', '9:16', '21:9', 'auto'],
            quality: ['auto', 'low', 'medium', 'high'],
            background: ['auto', 'opaque']
        },
        defaults: {
            aspectRatio: '1:1',
            quality: 'auto',
            background: 'auto'
        }
    },
    'openai/gpt-image-2.5-sunburst': {
        label: 'gpt-image-2.5-sunburst',
        group: 'OpenAI',
        params: {
            aspectRatio: ['1:1', '3:2', '2:3', '4:3', '3:4', '16:9', '9:16', '21:9', 'auto'],
            quality: ['auto', 'low', 'medium', 'high', 'xhigh', 'max'],
            background: ['auto', 'transparent', 'opaque']
        },
        defaults: {
            aspectRatio: '1:1',
            quality: 'auto',
            background: 'auto'
        }
    },
    'openai/gpt-image-2.5-flare': {
        label: 'gpt-image-2.5-flare',
        group: 'OpenAI',
        params: {
            aspectRatio: ['1:1', '3:2', '2:3', '4:3', '3:4', '16:9', '9:16', '21:9', 'auto'],
            quality: ['auto', 'low', 'medium', 'high', 'xhigh', 'max'],
            background: ['auto', 'transparent', 'opaque']
        },
        defaults: {
            aspectRatio: '1:1',
            quality: 'auto',
            background: 'auto'
        }
    },
    'bytedance-seed/seedream-4.5': {
        label: 'Seedream 4.5',
        group: 'Seedream',
        params: {
            aspectRatio: [
                '1:1',
                '1:2',
                '2:1',
                '2:3',
                '3:2',
                '3:4',
                '4:3',
                '4:5',
                '5:4',
                '9:16',
                '16:9',
                '9:19.5',
                '19.5:9',
                '9:20',
                '20:9',
                '9:21',
                '21:9',
                'auto'
            ],
            resolution: ['2K', '4K']
        },
        defaults: {
            aspectRatio: '1:1',
            resolution: '2K'
        }
    },
    'bytedance-seed/seedream-5-0-flash': {
        label: 'Seedream 5.0 Flash',
        group: 'Seedream',
        params: {
            aspectRatio: [
                '1:1',
                '1:2',
                '2:1',
                '2:3',
                '3:2',
                '3:4',
                '4:3',
                '4:5',
                '5:4',
                '9:16',
                '16:9',
                '9:19.5',
                '19.5:9',
                '9:20',
                '20:9',
                '9:21',
                '21:9',
                'auto'
            ],
            resolution: ['1K', '2K']
        },
        defaults: {
            aspectRatio: '1:1',
            resolution: '1K'
        }
    },
    'bytedance-seed/seedream-5-0-pro': {
        label: 'Seedream 5.0 Pro',
        group: 'Seedream',
        params: {
            aspectRatio: [
                '1:1',
                '1:2',
                '2:1',
                '2:3',
                '3:2',
                '3:4',
                '4:3',
                '4:5',
                '5:4',
                '9:16',
                '16:9',
                '9:19.5',
                '19.5:9',
                '9:20',
                '20:9',
                '9:21',
                '21:9',
                'auto'
            ],
            resolution: ['1K', '2K']
        },
        defaults: {
            aspectRatio: '1:1',
            resolution: '1K'
        }
    },
    'qwen/qwen-image-3-pro': {
        label: 'Qwen Image 3 Pro',
        group: 'Qwen',
        params: {
            aspectRatio: ['1:1', '1:2', '1:4', '2:1', '2:3', '3:2', '3:4', '4:1', '4:3', '4:5', '5:4', '9:16', '16:9'],
            resolution: ['1K', '2K']
        },
        defaults: {
            aspectRatio: '1:1',
            resolution: '1K'
        }
    }
} as const;
